export default {
  show() {
    return {
      endpoint: `/api/v1/statistics`,
      method: "GET",
      options: {}
    };
  }
};
